export default __webpack_public_path__ + "static/media/credit_cards.5d187e58.svg";